import { type BaseOptionType } from "antd/lib/select"

import {
  CONTRACT_STATUSES,
  CONTRACT_STATUSES_OBJ,
  type ContractStatuses
} from "../../constants/contract-statuses-keys.ts"

// A status the server offers that no tab names gets no tab of its own.
const STATUS_TABS: Partial<Record<ContractStatuses, ContractStatuses[]>> = {
  [CONTRACT_STATUSES.PENDING_TO_REVIEW]: [CONTRACT_STATUSES.PENDING_TO_REVIEW],
  // Everything past approval, until signing gets a tab of its own.
  [CONTRACT_STATUSES.APPROVED]: [
    CONTRACT_STATUSES.APPROVED,
    CONTRACT_STATUSES.SENT_TO_CLIENT,
    CONTRACT_STATUSES.SIGNED
  ],
  [CONTRACT_STATUSES.CANCELLED]: [CONTRACT_STATUSES.CANCELLED],
  [CONTRACT_STATUSES.DECLINED]: [CONTRACT_STATUSES.DECLINED]
}

export const buildStatusTabs = (
  options: BaseOptionType[] = []
): BaseOptionType[] => {
  const tabs: BaseOptionType[] = []
  for (const option of options) {
    const status = option?.value as ContractStatuses
    const statuses = STATUS_TABS[status]
    if (!statuses) continue
    tabs.push({
      ...option,
      value: statuses.join(","),
      label: CONTRACT_STATUSES_OBJ[status]?.label ?? option.label
    })
  }
  return tabs
}
